import type {ReactAction} from '@netx/core/bootstrap';
import {faCopy} from '@netx/core-icons';
import {canDuplicateSavedCart} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionDuplicateIcon = faCopy;

/**
 * Duplicate saved cart
 * @param params
 * @returns Action
 */
export const cartSavedActionDuplicate = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-duplicate',
	cb: () => dispatcher.trigger(CART_SAVED_EVENT.DUPLICATE, savedCart),
	enableTest: () => canDuplicateSavedCart(savedCart),
	icon: cartSavedActionDuplicateIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.DUPLICATE;
	},
	...params,
});

export default cartSavedActionDuplicate;
